// extracted by mini-css-extract-plugin
module.exports = {"list":"ArticleItemModuleTypes_list__REjbF","listItem":"ArticleItemModuleTypes_listItem__r_kCZ"};